<template>
  <form class="form" method="put">

    <div class="fontInvoice" id="appInvoiceVueComponent">
      <div class="invoiceBlocButton">
        <button @click.prevent="printing()" type="submit" class="appButtonModel2 appPrintButton">Imprimer</button>
        <button @click.prevent="returnTo()" type="submit" class="appButtonModel2 appPrintButton">Retour</button>
        <button @click.prevent="returnToHome()" type="submit" class="appButtonModel2 appPrintButton">Accueil</button>
      </div>
      <div class="invoiceHeader">
        <div class="invoiceHeaderText">
          <p id="invoiceHeaderTextTitle">E.I. Privilégia</p>
          <p>Coiffure à domicile</p>
          <p>88190 GOLBEY</p>
          <p>SIRET : 85340546200021</p>
          <p>Code APE/NAF : 9602A</p>
        </div>
        <div>
          <img src="../../assets/Logo1.png" alt="logo de Privilégia Coiffure" class="appLogoPrivilegiaInvoice" />
        </div>
      </div>

      <div class="invoiceInformations">
        <div class="invoiceInformationsNames">
          <p>Facture n°:</p>
          <p>Facturé à :</p>
          <p>Date : </p>
        </div>
        <div class="invoiceInformationsValues">
          <p>{{ invoice.number }}</p>
          <p>{{ invoice.client }}</p>
          <p id="dateOfInvoice"></p>
        </div>
      </div>

      <div class="invoiceTable">
        <table class="invoiceTable">
          <tr>
            <td class="invoiceTableWidth1 invoiceTableTD1 invoiceTableBorderLeft">Catégorie</td>
            <td class="invoiceTableWidth2 invoiceTableTD1">Désignation</td>
            <td class="invoiceTableWidth3 invoiceTableTD1 invoiceTableCenter">Taille</td>
            <td class="invoiceTableWidth3 invoiceTableTD1 invoiceTableCenter">Quantity</td>
            <td class="invoiceTableWidth3 invoiceTableTD1 invoiceTableCenter">Prix unitaire (€)</td>
            <td class="invoiceTableWidth3 invoiceTableTD1 invoiceTableCenter invoiceTableBorderRight">Prix total (€)</td>
          </tr>
          <tr :key="index" v-for="(lines, index) in invoice.lines">
            <td class="invoiceTableWidth1 invoiceTableTD2 invoiceTableBorderLeft">{{ lines.category }}</td>
            <td class="invoiceTableWidth2 invoiceTableTD2">{{ lines.designation }}</td>
            <td class="invoiceTableWidth3 invoiceTableTD2 invoiceTableCenter">{{ lines.size }}</td>
            <td class="invoiceTableWidth3 invoiceTableTD2 invoiceTableCenter">{{ lines.quantity }}</td>
            <td class="invoiceTableWidth3 invoiceTableTD2 invoiceTableCenter">{{ lines.price }} €</td>
            <td class="invoiceTableWidth3 invoiceTableTD2 invoiceTableCenter invoiceTableBorderRight">{{lines.total.toFixed(2) }} €</td>
          </tr>
        </table>
      </div>
      <br>
      <div class="invoiceTotal">
        <table class="invoiceTotal">
          <tr class="invoiceTableFirstLineTotal">
            <td class="invoiceTableWidth4 invoiceTableBorderLeft">Quantité</td>
            <td class="invoiceTableWidth3">Catégorie</td>
            <td class="invoiceTableWidth3">Montant €</td>
            <td class="invoiceTableWidth3">Réduction %</td>
            <td class="invoiceTableWidth3">Réduction €</td>
            <td class="invoiceTableWidth3 invoiceTableBorderRight">Total HT €</td>
          </tr>
          <tr>
            <td class="invoiceTableWidth4 invoiceTableBorderLeft invoiceTextLegal" id="totalNbPrestations"></td>
            <td class="invoiceTableWidth3 invoiceTextLegal">Prestations</td>
            <td class="invoiceTableWidth3 invoiceTextLegal" id="totalCostPrestations"></td>
            <td class="invoiceTableWidth3 invoiceTextLegal">{{ invoice.reduction }} %</td>
            <td class="invoiceTableWidth3 invoiceTextLegal" id="totalAmountReduction"></td>
            <td class="invoiceTableWidth3 invoiceTableBorderRight invoiceTextLegal"
              id="totalCostAfterReductionForPrestation"></td>
          </tr>
          <tr>
            <td class="invoiceTableWidth4 invoiceTableBorderLeft invoiceTextLegal" id="totalNbProducts"></td>
            <td class="invoiceTableWidth3 invoiceTextLegal">Ventes</td>
            <td class="invoiceTableWidth3 invoiceTextLegal" id="totalCostProducts"></td>
            <td class="invoiceTableWidth3 invoiceTextLegal">0 %</td>
            <td class="invoiceTableWidth3 invoiceTextLegal">0.00 €</td>
            <td class="invoiceTableWidth3 invoiceTableBorderRight invoiceTextLegal" id="totalCostProducts2"></td>
          </tr>
          <tr>
            <td class="invoiceTableWidth4 invoiceTableBorderLeft invoiceTextLegal" id="totalNbRemises"></td>
            <td class="invoiceTableWidth3 invoiceTextLegal">Remises</td>
            <td class="invoiceTableWidth3 invoiceTextLegal" id="totalCostRemises"></td>
            <td class="invoiceTableWidth3 invoiceTextLegal">-</td>
            <td class="invoiceTableWidth3 invoiceTextLegal">-</td>
            <td class="invoiceTableWidth3 invoiceTableBorderRight invoiceTextLegal" id="totalCostRemises2"></td>
          </tr>
          <tr class="invoiceTableFirstLineTotal">
            <td class="invoiceTableWidth4 invoiceTableBorderLeft invoiceTextLegal"></td>
            <td class="invoiceTableWidth3 invoiceTextLegal"></td>
            <td class="invoiceTableWidth3 invoiceTextLegal"></td>
            <td colspan="2" class="invoiceTableWidth3 invoiceTextLegal">Total HT à régler</td>
            <td class="invoiceTableWidth3 invoiceTableBorderRight invoiceTextLegal" id="totalprice">ZZZZZ</td>
          </tr>
        </table>
      </div>
      <div class="invoiceTypeOfPaiement">
        <p>Mode de règlement : </p>
        <p>{{ invoice.typeofpaiement }}</p>
      </div>
      <div class="invoiceFooter">
        <br>
        <br>
        <p class="invoiceTextLegal">Réductions applicables uniquement aux prestations adultes - non applicable sur les
          ventes ou prestations enfants</p>
        <p class="invoiceTextLegal">TVA non applicable - Article 239.B du CGI</p>
        <br>
        <p class="invoiceTextFinal">Merci pour votre confiance et à bientôt !</p>
      </div>
    </div>

  </form></template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  beforeCreate () {
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    if (!tokenWithDatas) { this.$router.push('/App/Login') }
  },
  name: 'appCollectionInvoice',
  data () {
    return {
      invoice: ''
    }
  },
  mounted () {
    let totalNbPrestations = 0
    let totalCostPrestations = 0
    let totalNbProducts = 0
    let totalCostProducts = 0
    let totalNbRemises = 0
    let totalCostRemises = 0
    let totalCostAfterReductionForPrestation = 0
    const url = document.location.href
    const idToGet = url.substring(url.lastIndexOf('=') + 1)
    const tokenWithDatas = JSON.parse(localStorage.getItem('userPrivilegia'))
    axios
      .get(('https://privilegia.fr/api/factures/' + idToGet), { headers: { Authorization: 'Bearer ' + tokenWithDatas.token } })
      .then((response) => {
        this.invoice = response.data
        var myTotalCounter = this.invoice.lines.length
        for (let myCounter = 0; myCounter < myTotalCounter; myCounter++) {
          if (this.invoice.lines[myCounter].category === 'Prestation') {
            totalNbPrestations = 0 + totalNbPrestations + this.invoice.lines[myCounter].quantity
            document.getElementById('totalNbPrestations').innerText = totalNbPrestations
          }
          if (this.invoice.lines[myCounter].category === 'Prestation') {
            totalCostPrestations = 0 + totalCostPrestations + this.invoice.lines[myCounter].total
            document.getElementById('totalCostPrestations').innerText = totalCostPrestations.toFixed(2) + ' €'
          }
          if (this.invoice.lines[myCounter].category === 'Vente') {
            totalNbProducts = 0 + totalNbProducts + this.invoice.lines[myCounter].quantity
            document.getElementById('totalNbProducts').innerText = totalNbProducts
          }
          if (this.invoice.lines[myCounter].category === 'Vente') {
            totalCostProducts = 0 + totalCostProducts + this.invoice.lines[myCounter].total
            document.getElementById('totalCostProducts').innerText = totalCostProducts.toFixed(2) + ' €'
            document.getElementById('totalCostProducts2').innerText = totalCostProducts.toFixed(2) + ' €'
          }
          if (this.invoice.lines[myCounter].category === 'Remise') {
            totalNbRemises = 0 + totalNbRemises + this.invoice.lines[myCounter].quantity
            document.getElementById('totalNbRemises').innerText = totalNbRemises
          }
          if (this.invoice.lines[myCounter].category === 'Remise') {
            totalCostRemises = 0 + totalCostRemises + this.invoice.lines[myCounter].total
            document.getElementById('totalCostRemises').innerText = totalCostRemises.toFixed(2) + ' €'
            document.getElementById('totalCostRemises2').innerText = totalCostRemises.toFixed(2) + ' €'
          }
        }
        totalCostAfterReductionForPrestation = totalCostPrestations - this.invoice.amountreduction
        document.getElementById('totalAmountReduction').innerText = this.invoice.amountreduction.toFixed(2) + ' €'
        document.getElementById('totalCostAfterReductionForPrestation').innerText = totalCostAfterReductionForPrestation.toFixed(2) + ' €'
        document.getElementById('totalprice').innerText = this.invoice.totalprice.toFixed(2) + ' €'
        let dateOfInvoice = moment(this.invoice.date).format('DD/MM/YYYY')
        document.getElementById('dateOfInvoice').innerText = dateOfInvoice
      })
  },
  methods: {
    printing () {
      print()
    },
    returnTo () {
      this.$router.go(-1)
    },
    returnToHome () {
      this.$router.push('/App/Home')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Application/AppCollectionInvoice.vue